import { OverlayModule } from '@angular/cdk/overlay';
import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatCommonModule, MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { MaterialTimePickerModule } from '@candidosales/material-time-picker';
import { MatSelectInfiniteScrollModule } from 'ng-mat-select-infinite-scroll';
import { SidebarModule } from 'ng-sidebar';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
    declarations: [


    ],
    imports: [

    ],
    exports: [
        MatIconModule,
        MatSelectModule,
        MatMenuModule,
        MatSidenavModule,
        MatTabsModule,
        MatTreeModule,
        MatFormFieldModule,
        MatCardModule,
        MatExpansionModule,
        MatTableModule,
        MatListModule,
        MatPaginatorModule,
        MatDatepickerModule,
        MatCheckboxModule,
        MatRadioModule,
        MatButtonModule,
        MatAutocompleteModule,
        MatInputModule,
        MatSliderModule,
        MatButtonToggleModule,
        SidebarModule,
        OverlayModule,
        MatSlideToggleModule,
        MatProgressSpinnerModule,
        MatNativeDateModule,
        MatSnackBarModule,
        MatChipsModule,
        MaterialTimePickerModule,
        MatTooltipModule,
        MatSelectInfiniteScrollModule,
        MatSortModule,
        NgxSpinnerModule,
        MatRippleModule,
        MatDialogModule,
        MatCommonModule,
    ]
})
export class MatControlsModule {

}